import { FC } from "react"
import { ProveedoresTableLenhoso } from "./ProveedoresTableLenhoso/ProveedoresTableLenhoso"
import { PropioTableLenhoso } from "./PropioTableLenhoso/PropioTableLenhoso"

export const ProveedoresLenhoso:FC<any> = (props):JSX.Element => {

    const {proveedores,data,dataMASTER,setData,setDataMASTER,changesFlag, setChangesFlag,fullData}  = props

    return (
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'92.5%',width:'100%'}}>
            {
                !proveedores?
                    <ProveedoresTableLenhoso
                        data={data?.lenhoso_proveedores_table}
                        setData={setData}
                        dataMASTER={dataMASTER?.lenhoso_proveedores_table}
                        fullData={fullData}
                        setDataMASTER={setDataMASTER}
                        changesFlag={changesFlag}
                        setChangesFlag={setChangesFlag}
                    />
                    :
                    <PropioTableLenhoso 
                        data={data?.lenhoso_propio_table}
                        setData={setData}
                        dataMASTER={dataMASTER?.lenhoso_propio_table}
                        fullData={fullData}
                        setDataMASTER={setDataMASTER}
                        changesFlag={changesFlag}
                        setChangesFlag={setChangesFlag}
                    />
            }
        </div>
    )
}